import React from 'react';
import { elementType } from 'prop-types';

const MockupIdentity = ({ component: Component, ...props }) => (
    <div style={{ textAlign: 'initial' }}>
        <Component {...props} />
    </div>
);

MockupIdentity.propTypes = {
    component: elementType,
};

export default MockupIdentity;
